<div class="avatar-editor-offcanvas">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ "Edit avatar" | translate }}</h5>
    <button [disabled]="isUploading" (click)="close()" class="btn-close" type="button"></button>
  </div>
  <div class="offcanvas-body">
    <astrobin-avatar-manager
      [user]="user"
      (avatarUpdated)="onAvatarUpdated($event)"
      (loadingChanged)="onLoadingChanged($event)"
    >
    </astrobin-avatar-manager>
  </div>
</div>
